import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useCurrentUser } from 'src/hooks';

type Props = {
  errorCode: string;
};

export const ErrorPage = ({ errorCode }: Props) => {
  const { user } = useCurrentUser();
  const [errorMessage, setErrorMessage] = useState('');
  const [errorLink, setErrorLink] = useState('');
  const [errorLinkText, setErrorLinkText] = useState('');

  const { t } = useTranslation();

  useEffect(() => {
    switch (errorCode) {
      case 'domain_not_allowed':
        setErrorMessage(
          'Your domain is not allowed to upgrade to the Organization+ Subscription.',
        );
        setErrorLink('/plus/cart-history');
        setErrorLinkText('Back to Cart History');
        return;
      case 'upgrade_to_org_not_allowed':
        setErrorMessage(
          `You need to visit the customer portal to upgrade to the Organization+ Subscription.`,
        );
        setErrorLink('/plus/manage-subscription');
        setErrorLinkText('Manage Subscription');
        return;
      case 'invalid_subscription_plan':
        setErrorMessage(
          `The subscription plan you've chosen is invalid. Please try again.`,
        );
        setErrorLink('/plus/upgrade');
        setErrorLinkText('Back to Upgrade');
        return;
      case 'subscription_already_exists':
        setErrorMessage(`You already have ${user?.subscription.tier} plan.`);
        setErrorLink('/plus/manage-subscription');
        setErrorLinkText('Manage Subscription');
        return;
      default:
        setErrorMessage(t('common.something_went_wrong'));
        setErrorLink('/plus/upgrade');
        setErrorLinkText('Back to Upgrade');
        return;
    }
  }, [errorCode, t, user?.subscription.tier]);

  return (
    <div className='mx-auto flex h-screen w-fit flex-col items-center justify-start gap-4 py-10'>
      <div className='fill-rose-500'>
        <HighlightOffIcon style={{ fontSize: '112px', fill: 'inherit' }} />
      </div>
      <h3 className='heading-200'>{errorMessage}</h3>
      {errorLink && (
        <Link
          to={errorLink}
          className='heading-100 text-primary underline transition hover:cursor-pointer hover:text-primary/80'
        >
          {errorLinkText}
        </Link>
      )}
    </div>
  );
};
